export default {
  "hierarchy": {
    "opacity": [
      "slider-opacity"
    ]
  },
  "props": {
    "default": {},
    "opacity": {}
  }
}